import Modal from '../../components/modal';
import Content from '../../content';
import EventEmitter from '../../../util/eventEmitter.js';

namespace('IO.Views.Nodes', function (exports) {
  'use strict';

  var Show,
    DynamicGroupForm = IO.Views.Components.DynamicGroupForm,
    ConfigurationWidget = IO.Views.Components.Rje.Configuration,
    ModalSummary = IO.Views.Components.Rje.ModalSummary,
    StatePoll = IO.Views.Components.Rje.StatePoll,
    ManagementWidget = IO.Views.Components.Rje.Management,
    VirtualNodesIndexView = IO.Views.VirtualNodes.Index;

  Show = Content.extend({
    dom: {
      CONFIGURATION_DROPDOWN: '.node-header .configuration-dropdown',
      CONFIG_MANAGEMENT: '.node-attributes .config-management',
      MASKED_PASSWORD: '.mask-password',
      CURRENT_HOSTNAME_FORM: '.node-form .current-hostname',
      WHEN_EDITING_BUTTONS:
        '.action-bar.right .configuration-dropdown, .action-bar.right .pjax-delete',
      NODES_FORM: '#regular-node-form',
      TYPE_SERVER: '.type-of-server-selector',
      FAILOVER_PREVIEW: '.failover-preview-button',
      FAILOVER_MODAL: '.failover-modal',
      NODE_FORM: '.node-form.main-form',
      NODE_GROUP_ID: '#node_node_group_id',
      NODE_GROUP_PATH: '.hidden.group-path',
      NODE_SAVE_CLUSTER: '.cluster-form .button.io-form-action-save',
      PUPPET_PROFILES: '.puppet_profiles_placeholder',
      VIRTUAL_PUPPET_PROFILES: '.virtual_node_puppet_profiles',
      VIRTUAL_NODES_FORM: '.node-form.virtual',
      DOCKER_IMGS: '.docker-images',
      DOCKER_IMGS_LAST_CHECKED: '.docker-imgs-last-checked',
      IMPACT_CANCEL: '#impact-form .io-form-action-cancel',
      IMPACT_FORM: '#impact-form',
    },

    STATUS_EXPIRATION_TIME_IN_SECONDS: 60,
    subscriptionIds: {},
    serviceCheckSubscriptionID: false,

    events: function () {
      var events = {};

      events['click ' + this.dom.FAILOVER_PREVIEW] = '_previewFailOver';
      events['click ' + this.dom.NODE_SAVE_CLUSTER] = '_warnAboutSlaveProps';
      events['click ' + this.dom.IMPACT_CANCEL] = '_impactCancel';

      return events;
    },

    beforeRender: function () {
      this.vnodesOpened = {};
      new ServerTypeWarning({ selector: this.dom.TYPE_SERVER });
      this.failOver = new NodesFailOver();
    },

    afterRender: function () {
      if (this.nodeConfiguration) {
        this.nodeConfiguration.start();
      }
      this.listenTo(this.dynamicForm, 'after:filter', this.checkRadioButtons);
      this.listenTo(this.statePoll, 'node:status', this._setFlagStatus);
      this.listenTo(
        this.statePoll,
        'error',
        _.bind(function () {
          this._setFlagStatus('unknown');
        }, this),
      );
      this._listenToServiceCheckChannel();
    },

    onDestroy: function () {
      if (this.configurationWidget) {
        this.configurationWidget.destroy();
      }
      if (this.virtualNodesIndexView) {
        this.virtualNodesIndexView.destroy();
      }
      if (this.form) {
        this.form.destroy();
      }
      if (this.statePoll) {
        this.statePoll.stop();
      }
      _.each(this.vnodesOpened, function (vnodeView) {
        vnodeView.destroy();
      });
      if (this.serviceCheckSubscriptionID) {
        Messenger.off(
          this._serviceCheckChannel(),
          this.serviceCheckSubscriptionID,
        );
      }
      this.dynamicForm.remove();
    },

    _setFlagStatus: function (status) {
      var capitalized =
        status.slice(0, 1).toUpperCase() + status.slice(1, status.length);

      this.$('.sensu-status')
        .removeClass(
          'sensu-status-online sensu-status-offline sensu-status-unknown',
        )
        .addClass('sensu-status-' + status)
        .prop('title', capitalized);
    },

    render: function () {
      var csrf = $('meta[name=csrf-token]').attr('content');

      this.dynamicForm = new DynamicGroupForm({
        el: this.$el,
        radio: true,
        formTarget: this.dom.NODES_FORM,
      });
      this.dynamicForm.render();

      this.puppetProfilesOrder = new PuppetProfilesOrder(
        this.$el.find('#regular-node-form'),
      );

      this.$(this.dom.MASKED_PASSWORD).maskPassword();
      this.hostname = this.$(this.dom.CURRENT_HOSTNAME_FORM).val();

      this.statePoll = new StatePoll();

      if (this.$(this.dom.CONFIGURATION_DROPDOWN).length) {
        this.configurationWidget = new ConfigurationWidget({
          el: this.$(this.dom.CONFIGURATION_DROPDOWN),
          poll: this.statePoll,
          name: 'node',
          csrf: csrf,
        });
        this.listenTo(this.configurationWidget, 'summary', this._showModal);
        this.statePoll.start(this.configurationWidget.getStatusURL());
      }

      if (this.$(this.dom.CONFIG_MANAGEMENT).length) {
        this.managementWidget = new ManagementWidget({
          el: this.$(this.dom.CONFIG_MANAGEMENT),
          poll: this.statePoll,
          name: 'node',
          csrf: csrf,
        });
      }

      this.virtualNodesIndexView = new VirtualNodesIndexView({
        el: '.virtual-nodes',
        poll: this.statePoll,
      });
      $('.node-form .select2select, .virtual-node-form .select2select').each(
        function (i, element) {
          $(element).select2({
            allowClear: true,
            placeholder: $(element).attr('placeholder'),
          });
        },
      );

      this.selectedPuppetProfiles = this._fetchSelectedPuppetProfiles();

      $('.virtual-node-row').each(function (i, item) {
        new PuppetProfilesOrder($(item));
      });
    },

    /*
      PRIVATE FUNCTIONS
    */

    _serviceCheckChannel: function () {
      return '/docker_imgs_' + this.hostname;
    },

    _listenToServiceCheckChannel: function () {
      if (!this.serviceCheckSubscriptionID) {
        this.serviceCheckSubscriptionID = Messenger.on(
          this._serviceCheckChannel(),
          this._refreshDockerImages.bind(this),
        );
      }
    },

    _refreshDockerImages: function (data) {
      var imgsContent = '';

      if (typeof data.error !== 'undefined') {
        imgsContent += `<div class="docker-imgs-error">
                          Unable to retrieve docker images.
                          <a href=${$(this.dom.NODE_GROUP_PATH).text()}> More Details.</a>
                        </div>`;
      } else if (data.images.length === 0) {
        imgsContent += '<p>No images found.</p>';
      } else {
        imgsContent += data.images.length + ' images found.';
        imgsContent +=
          '<a href="' +
          window.location +
          '/available_docker_images"> Check the full list</a>';
      }

      $(this.dom.DOCKER_IMGS).html(imgsContent);

      if (typeof data.last_checked !== 'undefined') {
        $(this.dom.DOCKER_IMGS_LAST_CHECKED).removeClass('hidden');
        EventEmitter.emit(
          '/timezone_' + this.hostname + '_date_update',
          data.last_checked,
        );
      }
    },

    _fetchSelectedPuppetProfiles: function () {
      var selectedPuppetProfiles = {},
        hostname;

      _.each(
        $(this.dom.VIRTUAL_NODES_FORM),
        function (form) {
          hostname = $(form).find('.current-hostname').val();
          selectedPuppetProfiles[hostname] = this._getSelectedPuppetModules(
            form,
            this.dom.VIRTUAL_PUPPET_PROFILES,
          );
        }.bind(this),
      );

      hostname = $(this.dom.CURRENT_HOSTNAME_FORM).val();
      selectedPuppetProfiles[hostname] = this._getSelectedPuppetModules(
        $(this.dom.NODES_FORM),
        this.dom.PUPPET_PROFILES,
      );

      return selectedPuppetProfiles;
    },

    _showModal: function (data) {
      if (!this.modalSummary) {
        this.modalSummary = new ModalSummary({
          id: 'summary-modal',
          data: data,
        });
        this.modalSummary._updateContent();
      } else {
        this.modalSummary.setData(data);
      }
      this.modalSummary.show();
    },

    _warnAboutSlaveProps: function (e) {
      var baseURL = $(this.dom.NODE_FORM).attr('action'),
        warnModal;

      warnModal = new IO.Views.Components.ConfirmationDialog({
        url: baseURL + '/impacted_cluster_resources.json',
        jst_template: 'nodes/impacted_cluster_resources', // eslint-disable-line camelcase
        method: 'GET',
        proceedIfDataIsEmpty: true,
        emptyCheck: function (data) {
          return (
            $.isEmptyObject(data.properties) && $.isEmptyObject(data.virtuals)
          );
        },
      });

      if ($('.fail-over-node-container p a')[0] === undefined) {
        return;
      }

      e.preventDefault();

      warnModal.impact({
        slave: $('.fail-over-node-container p a')[0].textContent,
        master: location.href.split('/').pop(),
      });
      warnModal.answer(function (shouldProceed) {
        if (shouldProceed) {
          $(e.target).unbind('submit').submit();
        }
        warnModal.destroy();
      });
    },

    _previewFailOver: function (e) {
      var previewModal;

      e.preventDefault();
      previewModal = new Modal({ id: 'modal-preview-failover', wait: true });
      previewModal.setContent($(this.dom.FAILOVER_MODAL).html());
      prettyPrint();
      previewModal.show();
    },

    _getSelectedPuppetModules: function (element, selector) {
      return $(element)
        .find(selector + ' option:selected')
        .map(function () {
          return $(this).text();
        })
        .get();
    },

    _impactCancel: function (e) {
      var form = $(this.dom.IMPACT_FORM);

      e.preventDefault();
      form.append('<input name="edit" type="hidden" value="1" />');
      form.submit();
    },
  });

  exports.Show = Show;
});
